import React from "react";
import { useParams } from "react-router-dom";
import CertificateDocument from "../components/student/CertificateDocument";
import { useVerifyCertificateQuery } from "../services/certificate";

const Certificate = () => {
  const { certificateId } = useParams();

  const { data, isLoading, isError, error } = useVerifyCertificateQuery(
    certificateId,
    {
      skip: !certificateId,
    },
  );

  const certificate = data?.success === true ? data.data : null;
  const isRevoked =
    String(certificate?.status || "").toLowerCase() === "revoked";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F3F4F6] px-4 py-10 font-['Roboto']">
      {isLoading ? (
        <p className="text-[#6B7280]">Loading certificate...</p>
      ) : null}

      {isError ? (
        <p className="text-[#EF4444]">
          {error?.data?.message || "Could not load certificate."}
        </p>
      ) : null}

      {!isLoading && !isError && data?.success === false ? (
        <p className="text-[#EF4444]">
          {data?.message || "Certificate not found."}
        </p>
      ) : null}

      {!isLoading && certificate ? (
        <div className="w-full max-w-[896px]">
          {isRevoked ? (
            <p className="mb-4 text-center text-sm font-medium text-[#B91C1C]">
              This certificate has been revoked
              {certificate.revokeReason
                ? `: ${certificate.revokeReason}`
                : "."}
            </p>
          ) : null}

          <CertificateDocument
            studentName={certificate.studentName}
            courseTitle={certificate.courseTitle}
            grade={certificate.grade}
            completionDate={certificate.completionDate}
            certificateId={certificate._id}
            instructorName={certificate.instructorName}
            issueDate={certificate.issueDate}
            isVerified={!isRevoked && certificate.status === "active"}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Certificate;
